import React, { useContext, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { DiamondSearchContext } from "../../utils/stateHandlers/contexts";

function FancyColorButton(props) {
  const { diamondState, dispatch } = useContext(DiamondSearchContext);
  const { searchQuery } = diamondState;
  const { color, switchToFancyColors } = props;
  const [isWhite, setIsWhite] = useState(true);

  const searchFields = Array.isArray(searchQuery?.fields)
    ? [...searchQuery.fields]
    : [];

  function isFcActive(colorName) {
    const selectedColorValue = searchFields.find(
      (field) => field.name === "FancyColor"
    );

    if (!selectedColorValue || !Array.isArray(selectedColorValue.values)) {
      return false;
    }

    return selectedColorValue.values.some(function (value) {
      return value.name === colorName;
    });
  }

  function selectionFilter(filterName, valueName) {
    const currentFields = Array.isArray(searchQuery?.fields)
      ? [...searchQuery.fields]
      : [];

    let workingFields = currentFields;

    if (filterName === "FancyColor") {
      workingFields = workingFields.filter(function (field) {
        return field.name !== "Color";
      });
    }

    const existingIndex = workingFields.findIndex(function (field) {
      return field.name === filterName;
    });

    if (existingIndex >= 0) {
      const existingField = workingFields[existingIndex];
      const existingValues = Array.isArray(existingField.values)
        ? [...existingField.values]
        : [];
      const valueIndex = existingValues.findIndex(function (value) {
        return value.name === valueName;
      });

      if (valueIndex >= 0) {
        existingValues.splice(valueIndex, 1);

        if (existingValues.length === 0) {
          workingFields = workingFields.filter(function (_, idx) {
            return idx !== existingIndex;
          });
          dispatch({
            type: "setShowFancyColorFilter",
            payload: false,
          });
        } else {
          workingFields[existingIndex] = {
            ...existingField,
            values: existingValues,
          };
        }
      } else {
        workingFields[existingIndex] = {
          ...existingField,
          values: existingValues.concat({ name: valueName }),
        };
      }
    } else {
      workingFields = workingFields.concat({
        name: filterName,
        values: [{ name: valueName }],
      });
    }

    dispatch({ type: "updateSearchQuery", payload: workingFields });
  }

  useEffect(() => {
    function isWhiteActive() {
      const colorValues = searchFields.find(
        (field) => field.name === "Color"
      )?.values;
      if (Array.isArray(colorValues) && colorValues.length > 0) {
        const allEqual = colorValues.every(function (value) {
          return ["D", "E", "F", "G", "H", "I", "J", "K"].includes(value.name);
        });
        setIsWhite(allEqual);
      } else {
        setIsWhite(false);
      }
    }

    isWhiteActive();
  }, [searchQuery]);

  return (
    <Button
      onClick={() => {
        if (color !== "White") {
          switchToFancyColors(color);
          selectionFilter("FancyColor", color);
        } else {
          switchToFancyColors(color);
        }
      }}
      disableElevation
      variant="contained"
      color={`diamond${color}`}
      sx={{
        width: "100%",
        textTransform: "capitalize",
        height: "3rem",
        border: "1px solid gray",
        lineHeight: 1,
        ...(isFcActive(color)
          ? {
              border: "2px solid black",
              color: "black",
            }
          : isWhite && color === "White"
          ? {
              border: "2px solid black",
              color: "black",
            }
          : null),
      }}
    >
      {color}
    </Button>
  );
}

export default FancyColorButton;
